import { Injectable } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { ConfigService } from '../../../config/config.service';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { handleProblem } from '../../problems/problem.service';
import { UniqaSyncJobGetQueryParamsInterface } from '../definitions/uniqa-sync-job-get-query-params.interface';
import { PagedResponseInterface } from 'src/app/shared/classes/paged-response.interface';
import { createUniqaSyncJobQueryParams } from '../uniqa-sync-jobs-get-query-params-factory';
import { UniqaSyncJobListItemResponse } from '../definitions/uniqa-sync-job-list-item-response.interface';

@Injectable()
export class GetUniqaSyncJobsService {
  constructor(private client: HttpClient, private configService: ConfigService) {}

  public getUniqaSyncJobs(paramsObj: UniqaSyncJobGetQueryParamsInterface): Observable<PagedResponseInterface<UniqaSyncJobListItemResponse>> {
    const url = `${this.configService.config.rest.apiV2Url}/uniqa-sync-jobs`;

    const params: HttpParams = createUniqaSyncJobQueryParams(paramsObj);

    return this.client.get<PagedResponseInterface<UniqaSyncJobListItemResponse>>(url, { params }).pipe(
      catchError(error => throwError(handleProblem(error)))
    );
  }
}
